import { Country } from './conf';
import { ICountry } from '@/api/common';

export const DEFAULT_COUNTRIES: ICountry[] = [
  {
    name: 'Argentina',
    code: Country.Argentina,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Australia',
    code: Country.Australia,
    defaultCurrency: 'AUD',
  },
  {
    name: 'Austria',
    code: Country.Austria,
    defaultCurrency: 'EUR',
  },
  // {
  //   name: 'Brazil',
  //   code: Country.Brazil,
  //   defaultCurrency: 'BRL',
  // },
  {
    name: 'Canada',
    code: Country.Canada,
    defaultCurrency: 'CAD',
  },
  {
    name: 'Chile',
    code: Country.Chile,
    defaultCurrency: 'EUR',
  },
  // {
  //   name: 'Congo, The Democratic Republic of the',
  //   code: Country.DemocraticRepublicOfTheCongo,
  //   defaultCurrency: 'EUR',
  // },
  {
    name: 'Denmark',
    code: Country.Denmark,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Finland',
    code: Country.Finland,
    defaultCurrency: 'EUR',
  },
  {
    name: 'French Southern Territories',
    code: Country.FrenchSouthernTerritories,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Germany',
    code: Country.Germany,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Ireland',
    code: Country.Ireland,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Italy',
    code: Country.Italy,
    defaultCurrency: 'EUR',
  },
  // {
  //   name: 'Japan',
  //   code: Country.Japan,
  //   defaultCurrency: 'EUR',
  // },
  {
    name: 'Kazakhstan',
    code: Country.Kazakhstan,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Kuwait',
    code: Country.Kuwait,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Lesotho',
    code: Country.Lesotho,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Luxembourg',
    code: Country.Luxembourg,
    defaultCurrency: 'EUR',
  },
  // {
  //   name: 'Malta',
  //   code: Country.Malta,
  //   defaultCurrency: 'EUR',
  // },
  {
    name: 'Mexico',
    code: Country.Mexico,
    defaultCurrency: 'EUR',
  },
  {
    name: 'New Zealand',
    code: Country.NewZealand,
    defaultCurrency: 'NZD',
  },
  {
    name: 'Norway',
    code: Country.Norway,
    defaultCurrency: 'NOK',
  },
  {
    name: 'Peru',
    code: Country.Peru,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Puerto Rico',
    code: Country.PuertoRico,
    defaultCurrency: 'USD',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    code: Country.SaintVincentAndTheGrenadines,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Slovenia',
    code: Country.Slovenia,
    defaultCurrency: 'EUR',
  },
  {
    name: 'South Africa',
    code: Country.SouthAfrica,
    defaultCurrency: 'ZAR',
  },
  {
    name: 'Switzerland',
    code: Country.Switzerland,
    defaultCurrency: 'EUR',
  },
  {
    name: 'United Arab Emirates',
    code: Country.UnitedArabEmirates,
    defaultCurrency: 'EUR',
  },
  {
    name: 'Uruguay',
    code: Country.Uruguay,
    defaultCurrency: 'EUR',
  },
];
